import { Menu, MenuItem, Button, Divider, Typography, Box, Tooltip, Stack } from '@mui/material';
import { useState, MouseEvent } from 'react';
import {
  menuItemSelectedStyle,
  sortButtonStyle,
  sortButtonTextStyle,
  sortingIconStyle,
  sortTextStyle,
  textBoxStyle,
} from './style';
import { AbyssIcon } from '@/assets/icons/AbyssIcon';
import { abyssColors } from '@/theme/colors';

type Sorting = {
  sortBy: string;
  sortDirection: number;
};

type PoiSortingProps = {
  sorting: Sorting;
  setSorting: React.Dispatch<React.SetStateAction<Sorting>>;
};

const SORT_OPTIONS: Record<string, string> = {
  createdAt: 'Date',
  deckRelativeHeight: 'POI Height from deck',
  'blister.maxHeight': 'MBH',
};

const SORT_ORDER = ['Ascending', 'Descending'];

export const PointOfInterestsSorting = ({ sorting, setSorting }: PoiSortingProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { sortBy, sortDirection } = sorting;
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSorting = (sort: Partial<Sorting>) => {
    setSorting((prev) => ({ ...prev, ...sort }));
    handleClose();
  };

  return (
    <>
      <Tooltip title={SORT_OPTIONS[sortBy]} placement="top-start">
        <Button
          sx={sortButtonStyle}
          variant="outlined"
          onClick={handleClick}
          id="review-panel-pois-sorting-button"
        >
          <Stack direction="row" alignItems="center" gap={0.5} sx={textBoxStyle}>
            <AbyssIcon iconName="sorting" style={sortingIconStyle} />
            <Typography sx={sortButtonTextStyle}>{SORT_OPTIONS[sortBy]}</Typography>
          </Stack>
        </Button>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              minWidth: '15rem',
              minHeight: '18.6rem',
            },
          },
        }}
      >
        <Typography sx={sortTextStyle}>Sort By</Typography>
        {Object.entries(SORT_OPTIONS).map(([key, label]) => (
          <MenuItem
            sx={{ color: abyssColors.primary[500], px: '0.8rem', py: '0.8rem' }}
            key={key}
            onClick={() => handleSorting({ sortBy: key })}
          >
            {key === sortBy && <Box sx={menuItemSelectedStyle} />}
            {label}
          </MenuItem>
        ))}
        <Divider />
        <Typography sx={sortTextStyle}>Sort order</Typography>
        {SORT_ORDER.map((option, index) => {
          const direction = index === 0 ? 1 : -1;
          return (
            <MenuItem
              sx={{ color: abyssColors.primary[500], px: '0.8rem', py: '0.8rem' }}
              key={option}
              onClick={() => handleSorting({ sortDirection: direction })}
            >
              {sortDirection === direction && <Box sx={menuItemSelectedStyle} />}
              {option}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
